import { jsx as _jsx } from "react/jsx-runtime";
import { Maximize } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useReactFlow } from "@xyflow/react";
import { ToolbarButton } from "./ToolbarButton";
export function FitViewButton({ durationMs = 300 } = {}) {
    const { t } = useTranslation();
    const { fitView } = useReactFlow();
    return /*#__PURE__*/ _jsx(ToolbarButton, {
        onClick: ()=>fitView({
                duration: durationMs
            }),
        tooltip: t("flowKit.toolbar.fitView"),
        children: /*#__PURE__*/ _jsx(Maximize, {
            className: "h-4 w-4"
        })
    });
}

//# sourceMappingURL=FitViewButton.js.map